export default __webpack_public_path__ + "static/media/uv11_kr_jing_b3.26920edc.mp3";